$(function(){
	const toTop = $('.toTop');
	const speed = 500;

	// 画面上部へスクロールする記述
	toTop.on('click', function(event){ // ボタンをクリックすると、
		event.preventDefault()
		$('body, html').animate({
		scrollTop: 0}, speed); // スクロールして画面上部へ戻る(0)
		return false;
	});
});